import { useState } from "react";
import { fmt } from "@/lib/load/products";

const TRACTOR = [{ id: "day", label: "Day cab", lb: 16500 }, { id: "sleeper", label: "Sleeper", lb: 18500 }];
const TANK = [{ id: "alum", label: "Aluminum tank", lb: 12000 }, { id: "steel", label: "Steel tank", lb: 15500 }];
const down100 = (n) => Math.max(0, Math.floor(n / 100) * 100);

const Seg = ({ items, value, onPick, testid, t }) => (
  <div className="seg">
    {items.map((x) => (
      <button key={x.id} type="button" className={value === x.id ? "seg-on" : ""} onClick={() => onPick(x.id)} data-testid={`${testid}-${x.id}`}>
        {t(x.label)} <small>{`~${fmt(x.lb)} lb`}</small>
      </button>
    ))}
  </div>
);

export const TareHelper = ({ tare, maxGross, onUse, t }) => {
  const [tractor, setTractor] = useState("day");
  const [tank, setTank] = useState("alum");
  const est = TRACTOR.find((x) => x.id === tractor).lb + TANK.find((x) => x.id === tank).lb;
  const room = Number(maxGross) - Number(tare);
  return (
    <div className="load-tare" data-testid="tare-helper">
      <div className="label">{t("Don't know your empty weight?")}</div>
      <Seg items={TRACTOR} value={tractor} onPick={setTractor} testid="tare-tractor" t={t} />
      <Seg items={TANK} value={tank} onPick={setTank} testid="tare-tank" t={t} />
      <button type="button" className="ghost-btn" onClick={() => onUse(est)} data-testid="tare-use-estimate">
        {t("Use about {n} lb", { n: fmt(est) })}
      </button>
      <div className="card-sub">{t("Most fuel rigs weigh 26,000–32,000 lb empty. For your exact number, weigh empty on a CAT scale with full fuel tanks and you in the cab.")}</div>
      {room > 0 && (
        <div className="load-tare-room" data-testid="tare-legal-gallons">
          {t("Room for fuel: {lb} lb ≈ {g} gal gas or {d} gal diesel", { lb: fmt(room), g: fmt(down100(room / 6.1)), d: fmt(down100(room / 7.1)) })}
        </div>
      )}
    </div>
  );
};
